import { render } from "./FairCrash.vue?vue&type=template&id=0558c48a&scoped=true"
import script from "./FairCrash.vue?vue&type=script&lang=js"
export * from "./FairCrash.vue?vue&type=script&lang=js"

import "./FairCrash.vue?vue&type=style&index=0&id=0558c48a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0558c48a"]])

export default __exports__